<div class="application-outer">

  <div class="form-outer">
    <form class="form" [formGroup]="form" autocomplete="off">
      <div class="col">
        <div class="form__group" *ngIf="false">
          <label class="form__label">Expiry Period of Appointment Link</label>
          <input type="text" formControlName="expiryPeriodOfAppointmentLink" class="form__control" pInputText
            maxlength="2" (keypress)="numberOnly($event)">
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.expiryPeriodOfAppointmentLink, 'required') || hasError(formFields.expiryPeriodOfAppointmentLink, 'whitespace')">{{validationMessages.expiryPeriodOfAppointmentLink.required}}</span>
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.expiryPeriodOfAppointmentLink, 'positiveInt')">{{validationMessages.expiryPeriodOfAppointmentLink.validNumber}}</span>
        </div>
        <div class="form__group">
          <!-- <label class="form__label">Pause Duration between calls (In Seconds)</label> -->
          <label class="form__label">Pause time between call (In sec.)</label>
          <input type="text" formControlName="pause" class="form__control" pInputText maxlength="2"
            (keypress)="numberOnly($event)">
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.pause, 'required') || hasError(formFields.pause, 'whitespace')">{{validationMessages.pause.required}}</span>
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.pause, 'positiveInt')">{{validationMessages.pause.validNumber}}</span>
        </div>
        <div class="form__group">
          <label class="form__label">Allow Therapist to Update Appointment Status </label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowTherapistToUpdateAppointmentStatus" value="True" label="Yes"
                inputId="AllowTherapistYes">
              </p-radioButton>
              <label class="radio-button-text" for="AllowTherapistYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowTherapistToUpdateAppointmentStatus" value="False" label="No"
                inputId="AllowTherapistNo">
              </p-radioButton>
              <label class="radio-button-text" for="AllowTherapistNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow Therapist to Update License, Device Certificate & Classification
            details</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowTherapistToUpdateLicense" value="True" label="Yes"
                inputId="AllowTherapistLicenseYes">
              </p-radioButton>
              <label class="radio-button-text" for="AllowTherapistLicenseYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowTherapistToUpdateLicense" value="False" label="No"
                inputId="AllowTherapistLicenseNo">
              </p-radioButton>
              <label class="radio-button-text" for="AllowTherapistLicenseNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow update the patient note in Brightree's Patient module</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowUpdateThePatientNoteInBrightTree" value="True" label="Yes"
                inputId="AllowUpdatePatientYes">
              </p-radioButton>
              <label class="radio-button-text" for="AllowUpdatePatientYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowUpdateThePatientNoteInBrightTree" value="False" label="No"
                inputId="AllowUpdatePatientNo">
              </p-radioButton>
              <label class="radio-button-text" for="AllowUpdatePatientNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow update the financial note in Brightree's Patient module</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowUpdateTheFinancialNoteInBrightTree" value="True" label="Yes"
                inputId="AllowUpdateFinancialYes">
              </p-radioButton>
              <label class="radio-button-text" for="AllowUpdateFinancialYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowUpdateTheFinancialNoteInBrightTree" value="False" label="No"
                inputId="AllowUpdateFinancialNo">
              </p-radioButton>
              <label class="radio-button-text" for="AllowUpdateFinancialNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow update into brightree system from appt. confirmation</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowUpdateAppointmentToBrightTree" value="True" label="Yes"
                inputId="AllowUpdatebrightreeYes">
              </p-radioButton>
              <label class="radio-button-text" for="AllowUpdatebrightreeYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowUpdateAppointmentToBrightTree" value="False" label="No"
                inputId="AllowUpdatebrightreeNo">
              </p-radioButton>
              <label class="radio-button-text" for="AllowUpdatebrightreeNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <!-- <label class="form__label">Patient's Default Appointment Location</label> -->
          <label class="form__label">Patient's Default Appointment Address</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="patientsdefaultappointmentlocation" value="BillingAddress" label="Billing"
                inputId="AppointmentAddressYes">
              </p-radioButton>
              <label class="radio-button-text" for="AppointmentAddressYes">Billing</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="patientsdefaultappointmentlocation" value="DeliveryAddress"
                label="Delivery" inputId="AppointmentAddressNo">
              </p-radioButton>
              <label class="radio-button-text" for="AppointmentAddressNo">Delivery</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <!-- <label class="form__label">Patient's Default Appointment Location</label> -->
          <label class="form__label">Default WIP Needed Date</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton [(ngModel)]="defaultwipneededdate" formControlName="defaultWIPNeededdate"
                value="AppointmentDate" label="Appointment" inputId="DefaultWIPNeededYes">
              </p-radioButton>
              <label class="radio-button-text" for="DefaultWIPNeededYes">Appointment</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton [(ngModel)]="defaultwipneededdate" formControlName="defaultWIPNeededdate"
                value="CurrentDate" label="Current" inputId="DefaultWIPNeededNo">
              </p-radioButton>
              <label class="radio-button-text" for="DefaultWIPNeededNo">Current</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Enable the Black out Days for Rescheduled Appointment</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowBlackoutForAppointment" value="True" label="Yes"
                inputId="allowBlackoutForAppointmentYes">
              </p-radioButton>
              <label class="radio-button-text" for="allowBlackoutForAppointmentYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowBlackoutForAppointment" value="False" label="No"
                inputId="allowBlackoutForAppointmentNo">
              </p-radioButton>
              <label class="radio-button-text" for="allowBlackoutForAppointmentNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Default Mode of Appointment</label>
          <div class="full-width mb-15 form__radio-outer">
            <p-radioButton formControlName="defaultModeofAppointment" value="RemoteSetup" label="Remote Setup"
              inputId="defaultModeofAppointmentRemoteSetup">
            </p-radioButton>
            <label class="radio-button-text" for="defaultModeofAppointmentRemoteSetup">Remote Setup</label>
          </div>
          <div class="full-width mb-15 form__radio-outer">
            <p-radioButton formControlName="defaultModeofAppointment" value="FacilityVisit" label="Facility Visit"
              inputId="defaultModeofAppointmentFacilityVisit">
            </p-radioButton>
            <label class="radio-button-text" for="defaultModeofAppointmentFacilityVisit">Facility Visit</label>
          </div>
          <div class="full-width form__radio-outer">
            <p-radioButton formControlName="defaultModeofAppointment" value="RoadHomeVisit" label="Road/Home Visit"
              inputId="defaultModeofAppointmentRoadHomeVisit">
            </p-radioButton>
            <label class="radio-button-text" for="defaultModeofAppointmentRoadHomeVisit">Road/Home Visit</label>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Enable the auto reconcile of Appointment</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="autoReconcileOfAppointment" value="True" label="Yes"
                inputId="autoReconcileOfAppointmentYes">
              </p-radioButton>
              <label class="radio-button-text" for="autoReconcileOfAppointmentYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="autoReconcileOfAppointment" value="False" label="No"
                inputId="autoReconcileOfAppointmentNo">
              </p-radioButton>
              <label class="radio-button-text" for="autoReconcileOfAppointmentNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow to use same online link for multiple Therapists</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="sameOnlineLinkForMultipleRT" value="True" label="Yes"
                inputId="sameOnlineLinkForMultipleRTYes">
              </p-radioButton>
              <label class="radio-button-text" for="sameOnlineLinkForMultipleRTYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="sameOnlineLinkForMultipleRT" value="False" label="No"
                inputId="sameOnlineLinkForMultipleRTNo">
              </p-radioButton>
              <label class="radio-button-text" for="sameOnlineLinkForMultipleRTNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group" *ngIf="false">
          <label class="form__label">Allow to send POD into brightree system from appt. confirmation</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowUpdatePODStatusToBrightTree" value="True" label="Yes"
                inputId="allowUpdatePODStatusToBrightTreeYes">
              </p-radioButton>
              <label class="radio-button-text" for="allowUpdatePODStatusToBrightTreeYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowUpdatePODStatusToBrightTree" value="False" label="No"
                inputId="allowUpdatePODStatusToBrightTreeNo">
              </p-radioButton>
              <label class="radio-button-text" for="allowUpdatePODStatusToBrightTreeNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group" *ngIf="false">
          <label class="form__label">Allow to append Order Note into brightree system from appt. confirmation</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowAppendOrderNoteToBrightTree" value="True" label="Yes"
                inputId="allowAppendOrderNoteToBrightTreeYes">
              </p-radioButton>
              <label class="radio-button-text" for="allowAppendOrderNoteToBrightTreeYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowAppendOrderNoteToBrightTree" value="False" label="No"
                inputId="allowAppendOrderNoteToBrightTreeNo">
              </p-radioButton>
              <label class="radio-button-text" for="allowAppendOrderNoteToBrightTreeNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group" *ngIf="showUpdatePODStatusClassificationTypeWise">
          <label class="form__label">Update POD Status classification type wise</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="updatePODStatusClassificationTypeWise" value="True" label="Yes"
                inputId="updatePODStatusClassificationTypeWiseYes">
              </p-radioButton>
              <label class="radio-button-text" for="updatePODStatusClassificationTypeWiseYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="updatePODStatusClassificationTypeWise" value="False" label="No"
                inputId="updatePODStatusClassificationTypeWiseNo">
              </p-radioButton>
              <label class="radio-button-text" for="updatePODStatusClassificationTypeWiseNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow DME to Update Order Note into brightree</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowDMEtoUpdateOrderNoteToBrightTree" value="True" label="Yes"
                inputId="allowDMEtoUpdateOrderNoteToBrightTreeYes">
              </p-radioButton>
              <label class="radio-button-text" for="allowDMEtoUpdateOrderNoteToBrightTreeYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowDMEtoUpdateOrderNoteToBrightTree" value="False" label="No"
                inputId="allowDMEtoUpdateOrderNoteToBrightTreeNo">
              </p-radioButton>
              <label class="radio-button-text" for="allowDMEtoUpdateOrderNoteToBrightTreeNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow DME to Update Delivery Note into brightree</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowDMEtoUpdateDeliveryNoteToBrightTree" value="True" label="Yes"
                inputId="allowDMEtoUpdateDeliveryNoteToBrightTreeYes">
              </p-radioButton>
              <label class="radio-button-text" for="allowDMEtoUpdateDeliveryNoteToBrightTreeYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowDMEtoUpdateDeliveryNoteToBrightTree" value="False" label="No"
                inputId="allowDMEtoUpdateDeliveryNoteToBrightTreeNo">
              </p-radioButton>
              <label class="radio-button-text" for="allowDMEtoUpdateDeliveryNoteToBrightTreeNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow DME to Update Delivery Address into brightree</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowDMEtoUpdateDeliveryAddressToBrightTree" value="True" label="Yes"
                inputId="allowDMEtoUpdateDeliveryAddressToBrightTreeYes">
              </p-radioButton>
              <label class="radio-button-text" for="allowDMEtoUpdateDeliveryAddressToBrightTreeYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowDMEtoUpdateDeliveryAddressToBrightTree" value="False" label="No"
                inputId="allowDMEtoUpdateDeliveryAddressToBrightTreeNo">
              </p-radioButton>
              <label class="radio-button-text" for="allowDMEtoUpdateDeliveryAddressToBrightTreeNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Allow DME to Update Wip Status on Rescheduled</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowDMEtoUpdateWipStatusRescheduled" value="True" label="Yes"
                inputId="allowDMEtoUpdateWipStatusRescheduledYes">
              </p-radioButton>
              <label class="radio-button-text" for="allowDMEtoUpdateWipStatusRescheduledYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="allowDMEtoUpdateWipStatusRescheduled" value="False" label="No"
                inputId="allowDMEtoUpdateWipStatusRescheduledNo">
              </p-radioButton>
              <label class="radio-button-text" for="allowDMEtoUpdateWipStatusRescheduledNo">No</label>
            </span>
          </div>
        </div>
        <div class="form__group">
          <label class="form__label">Check therapist state license for Remote & Road/Home appointment</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="checkTherapistStateLicense" value="True" label="Yes"
                inputId="checkTherapistStateLicenseYes">
              </p-radioButton>
              <label class="radio-button-text" for="checkTherapistStateLicenseYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="checkTherapistStateLicense" value="False" label="No"
                inputId="checkTherapistStateLicenseNo">
              </p-radioButton>
              <label class="radio-button-text" for="checkTherapistStateLicenseNo">No</label>
            </span>
          </div>
        </div>

        <div class="form__group">
          <label class="form__label">Check Therapist Classification Mapping</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="CheckTherapistClassification" value="True" label="Yes"
                inputId="CheckTherapistClassificationYes">
              </p-radioButton>
              <label class="radio-button-text" for="CheckTherapistClassificationYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="CheckTherapistClassification" value="False" label="No"
                inputId="CheckTherapistClassificationNo">
              </p-radioButton>
              <label class="radio-button-text" for="CheckTherapistClassificationNo">No</label>
            </span>
          </div>
        </div>

        <div class="form__group">
          <label class="form__label">Allow therapist notifications based on appointment dates</label>
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton formControlName="TherapistNotificationBasedOnDate" value="CurrentDate" label="Current Date"
                inputId="TherapistNotificationBasedOnDateCurrentDate">
              </p-radioButton>
              <label class="radio-button-text" for="TherapistNotificationBasedOnDateCurrentDate">Current Date</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton formControlName="TherapistNotificationBasedOnDate" value="AllDates" label="All Dates"
                inputId="TherapistNotificationBasedOnDateAllDates">
              </p-radioButton>
              <label class="radio-button-text" for="TherapistNotificationBasedOnDateAllDates">All Dates</label>
            </span>
          </div>
        </div>

        <div class="form__group">
          <label class="form__label">WIP Status Update for Booked Appointments as per</label>
          <div class="full-width mb-15 form__radio-outer">
            <p-radioButton formControlName="WIPStatusUpdate" value="ClassificationMapping"
              label="Classification Mapping" inputId="ClassificationMapping">
            </p-radioButton>
            <label class="radio-button-text" for="ClassificationMapping">Classification Mapping</label>
          </div>
          <div class="full-width mb-15 form__radio-outer">
            <p-radioButton formControlName="WIPStatusUpdate" value="StatusMapping" label="Status Mapping"
              inputId="StatusMapping">
            </p-radioButton>
            <label class="radio-button-text" for="StatusMapping">Status Mapping</label>
          </div>
        </div>

        <div *ngIf="isGroupAppointmentFeatureSubscribed" class="form__group">
          <label class="form__label">Group Appointment Reassignment Mode</label>
          <div class="full-width mb-15 form__radio-outer">
            <p-radioButton formControlName="AppointmentReassignmentMode" value="IndividualPatientReassignment"
              label="Individual Patient Reassignment" inputId="IndividualPatientReassignment">
            </p-radioButton>
            <label class="radio-button-text" for="IndividualPatientReassignment">Individual Patient Reassignment</label>
          </div>
          <div class="full-width mb-15 form__radio-outer">
            <p-radioButton formControlName="AppointmentReassignmentMode" value="EntireGroupReassignment" label="Entire Group Reassignment"
              inputId="EntireGroupReassignment">
            </p-radioButton>
            <label class="radio-button-text" for="EntireGroupReassignment">Entire Group Reassignment</label>
          </div>
        </div>

        <div class="form__group">
          <label class="form__label">Maximum unanswered calls for sales order to be marked as 'Void Review'</label>
          <p-select class="form__dropdown select-box" placeholder="Select Days" optionLabel="title"
            formControlName="allowMaxCallBeforeVoidReviewApptment" [(ngModel)]="selectedExactDays"
            (ngModelChange)="onChange($event)" [options]="ExactDate">
          </p-select>
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.expiryPeriodOfAppointmentLink, 'required') || hasError(formFields.expiryPeriodOfAppointmentLink, 'whitespace')">{{validationMessages.expiryPeriodOfAppointmentLink.required}}</span>
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.expiryPeriodOfAppointmentLink, 'positiveInt')">{{validationMessages.expiryPeriodOfAppointmentLink.validNumber}}</span>
          <!-- <div *ngIf="hasError(formFields.allowMaxCallBeforeVoidReviewApptment, 'required')" class="invalid-feedback">
            {{validationMessages.allowMaxCallBeforeVoidReviewApptment.required}}
            </div> -->
          <p-dialog [(visible)]="isChange" styleClass="display-close-icon" [modal]="true" appendTo="body">
            <div class="cd-popup appt-massages-outer" role="alert" *ngIf="isChange">
              <div class="cd-popup-container text-center appt-massages-block">
                <h2 class="appt-massages-block__title-box">Information</h2>

                <div class="appt-massages-block__content-box">
                  <div *ngIf="orgSelectedExactDays.value > selectedExactDays.value">
                    <p *ngIf="totalmoreThan3 > 0">You are updating the configuration to automatically mark sales orders
                      as 'Void Review' after {{selectedExactDays.value}} calls instead of
                      {{orgSelectedExactDays.value}}. Consequently, the following sales orders (total
                      {{this.totalmoreThan3}} Sales orders) with respective statuses will be marked as 'Void Review'
                      once the change is saved.

                      The details of Sales orders are as per follow:
                    </p>

                    <p *ngIf="totalmoreThan3 === 0">You are updating the configuration to automatically mark sales
                      orders as 'Void Review' after {{selectedExactDays.value}} calls instead of
                      {{orgSelectedExactDays.value}}. Consequently, the following sales orders (total
                      {{this.totalmoreThan3}} Sales orders) with respective statuses will be marked as 'Void Review'
                      once the change is saved.
                    </p>

                    <div class="appt-massages-block__table-block" *ngIf="totalmoreThan3 > 0">
                      <div class="appt-massages-block__table-box">
                        <table class="appt-massages-block__custom-tables">
                          <thead>
                            <tr>
                              <th class="appt-massages-block__th">Sr No</th>
                              <th class="appt-massages-block__th">Sales Order</th>
                              <th class="appt-massages-block__th">Current Status</th>
                            </tr>
                          </thead>

                          <tbody *ngFor="let salesorder of salesOrders; index as i">
                            <tr>
                              <!-- <td class="appt-massages-block__td">{{salesorder.crmSalesOrderAPPId}} </td>
                                              <td class="appt-massages-block__td">SO#{{salesorder.count}}</td>
                                              <td class="appt-massages-block__td">{{salesorder.awaitingType}}</td> -->
                              <td class="appt-massages-block__td">{{i+1}} </td>
                              <td class="appt-massages-block__td">SO#{{salesorder.crmSalesOrderAPPId}}</td>
                              <td class="appt-massages-block__td">{{ salesorder['crmCallCount']==0 ?'Awaiting First
                                Call':
                                salesorder['crmCallCount']==1 ?'Awaiting Second Call':
                                salesorder['crmCallCount']==2 ?'Awaiting Third Call':
                                salesorder['crmCallCount']==3 ?'Awaiting Fourth Call':
                                salesorder['crmCallCount']==4 ?'Awaiting Fifth Call':
                                salesorder['crmCallCount']==5 ?'Awaiting Sixth Call':
                                salesorder['crmCallCount']==6 ?'Awaiting Seventh Call':
                                salesorder['crmCallCount']==7 ?'Awaiting Eighth Call':
                                salesorder['crmCallCount']==8 ?'Awaiting Ninth Call':'Awaiting Tenth Call'}}</td>

                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="(orgSelectedExactDays.value < selectedExactDays.value)">
                    <div>
                      <p>You are updating the configuration to automatically mark sales orders as 'Void Review' after
                        {{selectedExactDays.value}} (to be count of calls) calls instead of
                        {{orgSelectedExactDays.value}} (previously set count of calls) . Once the configuration is
                        saved, the changes will apply to both existing and new sales orders.
                        Click on 'Save' button to apply the changes.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="cd-buttons">
                    <button class="btn btn--primary mr-2" (click)="onOkay()">Okay</button>
                  </div>
                </div>
              </div>
            </div>
          </p-dialog>
        </div>




        <!-- <div class="form__group">        
          <label class="form__label">Maximum unanswered calls for sales order to be marked as 'Void Review'</label>
          <input type="text" formControlName="allowMaxCallBeforeVoidReviewApptment" class="form__control" [min]=3 [max]=10 pInputText maxlength="2"
            (keypress)="numberOnly($event)">
            <span class="invalid-feedback"
            *ngIf="hasError(formFields.allowMaxCallBeforeVoidReviewApptment, 'required') || hasError(formFields.allowMaxCallBeforeVoidReviewApptment, 'whitespace')">{{validationMessages.allowMaxCallBeforeVoidReviewApptment.required}}</span>
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.allowMaxCallBeforeVoidReviewApptment, 'positiveInt')">{{validationMessages.allowMaxCallBeforeVoidReviewApptment.validNumber}}</span>
        </div> -->

        <div class="form__group enable-remote">
          <label class="form__label">Enable the Remote Appointment</label>
          <div class="clearfix" style="max-width: 100%; width: 100%;"></div>
          <div class="full-width">
            <div class="input-edit-table" [ngClass]="telemedEditStatus ? 'edit-box' : ''">
              <p-checkbox name="group7" binary="true" label="" [(ngModel)]="telemedSelected"
                formControlName="telemedSelected" inputId="telemedSelected"></p-checkbox>
              <input type="text" class="form__control" formControlName="telemedTitle" pInputText maxlength="100" />

              <div class="action-icon">
                <a href="javascript:void(0);" (click)="EditTelemedTitle()" class="edit-icon">
                  <i class="edit-icon-new"></i>
                </a>
                <a href="javascript:void(0);" (click)="saveTelemedTitle()" class="save-icon">
                  <i class="ic check-ic-small"></i>
                </a>
                <a href="javascript:void(0);" (click)="cancelTelemedTitle()" class="cancel-icon">
                  <i class="ic cancel-ic-small"></i>
                </a>
              </div>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.telemedTitle, 'required') || hasError(formFields.telemedTitle, 'whitespace')">{{validationMessages.telemedTitle.required}}</span>
            </div>
          </div>

          <div class="full-width">
            <div class="input-edit-table" [ngClass]="OnlineMeetingEditStatus ? 'edit-box' : ''">
              <p-checkbox name="group7" binary="true" label="" [(ngModel)]="OnlineMeetingSelected"
                formControlName="onlineMeetingSelected"></p-checkbox>
              <input type="text" class="form__control" formControlName="onlineMeetingTitle" pInputText
                maxlength="100" />

              <div class="action-icon">
                <a href="javascript:void(0);" (click)="EditOnlineMeetingTitle()" class="edit-icon">
                  <i class="edit-icon-new"></i>
                </a>

                <a href="javascript:void(0);" (click)="saveOnlineMeetingTitle()" class="save-icon">
                  <i class="ic check-ic-small"></i>
                </a>
                <a href="javascript:void(0);" (click)="cancelOnlineMeetingTitle()" class="cancel-icon">
                  <i class="ic cancel-ic-small"></i>
                </a>
              </div>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.onlineMeetingTitle, 'required') || hasError(formFields.onlineMeetingTitle, 'whitespace')">{{validationMessages.onlineMeetingTitle.required}}</span>
            </div>
          </div>

          <div class="full-width">
            <div class="input-edit-table" [ngClass]="SelfGuidedEditStatus ? 'edit-box' : ''">
              <p-checkbox name="group7" binary="true" label="" [(ngModel)]="SelfGuidedSelected"
                formControlName="selfGuidedSelected"></p-checkbox>
              <input type="text" class="form__control" formControlName="selfGuidedTitle" pInputText maxlength="100" />

              <div class="action-icon">
                <a href="javascript:void(0);" (click)="EditSelfGuidedTitle()" class="edit-icon">
                  <i class="edit-icon-new"></i>
                </a>

                <a href="javascript:void(0);" (click)="saveSelfGuidedTitle()" class="save-icon">
                  <i class="ic check-ic-small"></i>
                </a>
                <a href="javascript:void(0);" (click)="cancelSelfGuidedTitle()" class="cancel-icon">
                  <i class="ic cancel-ic-small"></i>
                </a>
              </div>
              <span class="invalid-feedback"
                *ngIf="hasError(formFields.selfGuidedTitle, 'required') || hasError(formFields.selfGuidedTitle, 'whitespace')">{{validationMessages.selfGuidedTitle.required}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <button class="btn btn--primary" (click)="onSubmit()" type="submit">Save</button>
        <button class="btn btn--secondary" routerLink="/admin/settings">Cancel</button>
      </div>
    </form>
  </div>



</div>
<div class="loader-block" *ngIf="loading">
  <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
  </p-progressSpinner>
</div>